import React, { useState } from 'react';
import { shopApi } from '../../services/endpoints';
import { useApiData, StateBlock } from './useApiData';

const SOURCE_LABELS = { sheba: 'Sheba', partner: 'Partner', dropship: 'Dropship' };

export default function Shop() {
  const [source, setSource] = useState('');
  const { data: products, loading, error, reload } = useApiData(
    () => shopApi.listProducts(source ? { source } : undefined),
    [source]
  );

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Shop</h1>
        <select
          value={source}
          onChange={(e) => setSource(e.target.value)}
          className="bg-white/5 border border-white/20 rounded-lg px-3 py-1.5 text-sm text-white"
        >
          <option value="">All sources</option>
          <option value="sheba">Sheba</option>
          <option value="partner">Partner</option>
          <option value="dropship">Dropship</option>
        </select>
      </div>

      <p className="text-white/40 text-sm mb-6 max-w-2xl">
        Products sold or offered through Sheba — separate from{' '}
        <a href="/dashboard/compatible-devices" className="text-[#00d4ff]">Compatible Devices</a>,
        which lists what Sheba can integrate with regardless of where you
        bought it. Checkout is not yet available in this foundation release.
      </p>

      <StateBlock loading={loading} error={error} onRetry={reload} isEmpty={products?.length === 0} emptyLabel="No products in the catalogue yet.">
        <div className="grid md:grid-cols-3 gap-4">
          {products?.map((p) => (
            <div key={p.id} className="glass rounded-xl overflow-hidden">
              <div className="aspect-square bg-black/30 flex items-center justify-center text-white/20 text-xs">
                {p.images?.[0] ? (
                  <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover" />
                ) : (
                  'No image'
                )}
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <p className="font-medium text-sm">{p.name}</p>
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-white/10 text-white/50">
                    {SOURCE_LABELS[p.source] || p.source}
                  </span>
                </div>
                {p.brand && <p className="text-white/40 text-xs mt-1">{p.brand}</p>}
                <p className="text-[#00d4ff] font-semibold mt-2">{p.currency} {p.retail_price}</p>
              </div>
            </div>
          ))}
        </div>
      </StateBlock>
    </div>
  );
}
